// extracted by mini-css-extract-plugin
module.exports = {"attention":"attention-3WCI4","attention__title":"attention__title-1tH7n","attention__text":"attention__text-3CNZg"};